import React from 'react';

import { Box, BoxProps } from './box';

export type FullBoxProps = BoxProps;

export const FullBox = (props: FullBoxProps) => (
  <Box fullSize centeredContent noSpacing {...props} />
);
